export const supportWhatsappNumber = '5511996802265';
export const supportWhatsappNumberDisplay = '11 99680-2265';
const whatsappBaseUrl = 'https://api.whatsapp.com/send';

export const createWhatsappUrl = ({ message, number } = {}) => {
  const messageText = message || 'Olá, sou fornecedor e preciso de ajuda.';
  const url = new URL(whatsappBaseUrl);
  url.searchParams.set('phone', number || supportWhatsappNumber);
  url.searchParams.set('text', messageText);
  return url.toString();
};

export const supplierSupportWhatsappURL = createWhatsappUrl();

export const retailerSupportWhatsappURL = createWhatsappUrl({
  message: 'Olá, sou logista e preciso de ajuda.',
});

export const getOrderReviewWhatsappURL = orderName => {
  const userName = window.sessionStorage.getItem('fornecedorName');
  const message = `Olá, sou ${userName} e preciso de ajuda com a ordem ${orderName}. Obrigado!`;
  return createWhatsappUrl({ number: supportWhatsappNumber, message });
};
